module.exports = __webpack_public_path__ + "333f5841148dc0b536e2db6d83072154.svg";